import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DialogShellComponent, OutlinedButtonComponent } from '@custom-components';

/**
 * Read-only dialog showing the Terms of Service, opened from the login page. The body
 * is held in the `login.terms.body` translation.
 */
@Component({
  selector: 'xemex-login-terms-dialog',
  imports: [MatDialogModule, TranslateModule, DialogShellComponent, OutlinedButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './login-terms-dialog.component.html',
})
export class LoginTermsDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<LoginTermsDialogComponent>);

  onClose(): void {
    this.dialogRef.close();
  }
}
